/* istanbul ignore file */
import { createTheme } from '@mui/material/styles';

import { CIRCULAR_STD, loadBrandFont } from 'reservations/brand/helpers/fonts';
import { getComponents } from 'reservations/brand/helpers/v1/components';
import { createPalette } from 'reservations/brand/helpers/v1/palette';
import { getTypography } from 'reservations/brand/helpers/v1/typography';
import { createBrandMuiTheme } from 'reservations/brand/helpers/v2/theme';
import { BrandFont, BrandStyles } from 'reservations/brand/types/brand';

export const defaultTypography = {
  fontFamily: `${CIRCULAR_STD}, Helvetica Neue, Arial, sans-serif`
};

export const getTheme = (
  hasFeature: boolean,
  primaryColor: string,
  styles: BrandStyles,
  fonts: BrandFont[]
) =>
  hasFeature
    ? createBrandMuiTheme(styles, fonts)
    : createMuiTheme(primaryColor);

export function createMuiTheme(primaryColor: string) {
  const palette = createPalette(primaryColor);
  const brandFontFaces = loadBrandFont();
  const components = getComponents(brandFontFaces);
  const typography = getTypography();

  return createTheme({
    typography,
    palette,
    components
  });
}

export type MuiTheme = ReturnType<typeof createMuiTheme>;
